module.exports = __webpack_public_path__ + "img/right-img.dfe758ff.png";